import getApi from '../../../api/apisauceConfig'
import { Team } from '../../../model/Team'
import { TeamMutationPayload } from './teams.model'

export const postTeam = (payload: TeamMutationPayload) =>
  getApi().post<Team>('/admin/teams', payload)
